import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberMillionRound'
})
export class NumberMillionRoundPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value >= 0 && value !== null) {
      if (value.toString().indexOf(".") > -1) {
        let val = parseFloat(value.toString()).toFixed(2);
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace(".", ",");
      } else {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      }
    }
    return '-';
  }

}
